import { styled } from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
export const ButtonGroupContainer = styled.div `
  z-index: 0;
  position: relative;
  display: flex;

  white-space: nowrap;

  ${(props) => props.$stretch && 'width: 100%;'}

  & > * {
    position: relative;

    &:not(:first-child) {
      margin-left: -${pxToRem(1)};
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    &:not(:last-child) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    &:focus-visible,
    &:active {
      z-index: 2;
    }
  }
`;
